import { Countys } from "@/common/baseConfig";
import { underlineToHump } from "@/common/Utils";
class LoadVue {
  /** query参数 */
  public query: { [key: string]: string | undefined | number } = {};
  /** 当前新闻类型 */
  private type: string = "";
  /** 当前路由名 */
  private name: string = "";
  /**
   * 获取Query参数
   */
  private getQueryString() {
    // 类型
    this.type = location.href.split("#")[1].split("/")[1];
    // 文件名
    this.name = underlineToHump(
      location.href.split("/").lastChild.split("?")[0]
    );
    const isQuery = location.href.split("#")[1];

    const query = isQuery.split("?")[1];
    console.log(query);
    query.split("&").forEach(item => {
      if (item) {
        const parm = item.split("=");
        this.query[parm[0]] = parm[1];
      }
    });
    return null;
  }

  /**
   * 获取符合规则的模板路径
   * @param list 模板路径集合
   */
  private getTemplate(list: string[]): string {
    // 20200527 陈磊修改
    // 修改目标：首先通过tempId筛选  然后一次从type  appId  name开始筛选 如果找不到的情况下，用default
    if (this.query.tempId) {
      let template = list.find(
        item => item.indexOf(this.query.tempId as string) > 0
      );
      if (template) {
        return template;
      }
    }
    // 依次从type  appId  name开始寻找
    const typeList = list.filter(item => {
      const type = item.split("/")[1];
      if (type == this.type) {
        return item;
      }
    });
    let defaultList: string[] = [];
    let appList = typeList.filter(item => {
      const county = item.split("/")[2];
      // 有appId 并且有appName
      if (this.query.appId && Countys[this.query.appId as number]) {
        if (county == Countys[this.query.appId as number]) {
          return item;
        } else {
          // 如果 有appId 也有appName  但是路径中还是找不到改app的路径，走default
          if (county == "default") {
            defaultList.push(item);
          }
        }
      } else {
        // 如果没有appId的情况 就拿default
        if (county == "default") {
          defaultList.push(item);
        }
      }
    });
    //当没有区县文件夹时 取默认值
    if (!appList.length) {
      appList = defaultList;
    }
    let result = appList.find(item => item.indexOf(this.name) > -1);

    // 如果路由没有对比到，还是走默认
    if (!result) {
      appList = defaultList;
      result = appList.find(item => item.indexOf(this.name) > -1);
    }

    console.log(result || appList[0] || typeList[0] || list[0]);
    return result || appList[0] || typeList[0] || list[0]; // 保证程序不存在找不到模板
  }

  // private reLoad() {
  //   let url = location.href;
  //   const newUrl = url.split("#")[0].split("?")[0] + "#" + url.split("#")[1];
  //   window.location.replace(newUrl);
  // }
  /** 获取应该加载的Vue模板 */
  public getVue() {
    // this.reLoad();
    this.getQueryString();
    const vues = require.context("../county", true, /.vue$/);
    return vues(this.getTemplate(vues.keys())).default;
  }
}
export default LoadVue;
